
import kebabCase from 'lodash.kebabcase';
import type { ClickOrPressEvent } from 'types/mouseEvents';

// *****To update this file see `tools/generate-icon-imports.mjs`*****

import { ReactComponent as ArrowDown } from 'assets/icons/arrow-down.svg?react';
import { ReactComponent as ArrowLeft } from 'assets/icons/arrow-left.svg?react';
import { ReactComponent as ArrowRight } from 'assets/icons/arrow-right.svg?react';
import { ReactComponent as ArrowUp } from 'assets/icons/arrow-up.svg?react';
import { ReactComponent as Calendar } from 'assets/icons/calendar.svg?react';
import { ReactComponent as ChevronDown } from 'assets/icons/chevron-down.svg?react';
import { ReactComponent as ChevronLeft } from 'assets/icons/chevron-left.svg?react';
import { ReactComponent as ChevronRight } from 'assets/icons/chevron-right.svg?react';
import { ReactComponent as ChevronUp } from 'assets/icons/chevron-up.svg?react';
import { ReactComponent as DiscoverTune } from 'assets/icons/discover-tune.svg?react';
import { ReactComponent as ExternalLink } from 'assets/icons/external-link.svg?react';
import { ReactComponent as Menu } from 'assets/icons/menu.svg?react';
import { ReactComponent as Minus } from 'assets/icons/minus.svg?react';
import { ReactComponent as MoreHorizontal } from 'assets/icons/more-horizontal.svg?react';
import { ReactComponent as Office } from 'assets/icons/office.svg?react';
import { ReactComponent as Play } from 'assets/icons/play.svg?react';
import { ReactComponent as Plus } from 'assets/icons/plus.svg?react';
import { ReactComponent as Publications } from 'assets/icons/publications.svg?react';
import { ReactComponent as Restart } from 'assets/icons/restart.svg?react';
import { ReactComponent as Search } from 'assets/icons/search.svg?react';
import { ReactComponent as Star } from 'assets/icons/star.svg?react';
import { ReactComponent as Time } from 'assets/icons/time.svg?react';
import { ReactComponent as Trolley } from 'assets/icons/trolley.svg?react';
import { ReactComponent as UserSolid } from 'assets/icons/user-solid.svg?react';
import { ReactComponent as XCircle } from 'assets/icons/x-circle.svg?react';
import { ReactComponent as X } from 'assets/icons/x.svg?react';

export type IconString =

| 'arrow-down'
| 'arrow-left'
| 'arrow-right'
| 'arrow-up'
| 'calendar'
| 'chevron-down'
| 'chevron-left'
| 'chevron-right'
| 'chevron-up'
| 'discover-tune'
| 'external-link'
| 'menu'
| 'minus'
| 'more-horizontal'
| 'office'
| 'play'
| 'plus'
| 'publications'
| 'restart'
| 'search'
| 'star'
| 'time'
| 'trolley'
| 'user-solid'
| 'x-circle'
| 'x';

export type IconSVG = React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
export const allIconComponents: Record<IconString, IconSVG> = {
    'arrow-down': ArrowDown,
    'arrow-left': ArrowLeft,
    'arrow-right': ArrowRight,
    'arrow-up': ArrowUp,
    calendar: Calendar,
    'chevron-down': ChevronDown,
    'chevron-left': ChevronLeft,
    'chevron-right': ChevronRight,
    'chevron-up': ChevronUp,
    'discover-tune': DiscoverTune,
    'external-link': ExternalLink,
    menu: Menu,
    minus: Minus,
    'more-horizontal': MoreHorizontal,
    office: Office,
    play: Play,
    plus: Plus,
    publications: Publications,
    restart: Restart,
    search: Search,
    star: Star,
    time: Time,
    trolley: Trolley,
    'user-solid': UserSolid,
    'x-circle': XCircle,
    x: X,
};

interface IconProps {
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    icon: IconString | string;
    className?: string;
    // eslint-disable-next-line no-unused-vars
    onClick?: (event: ClickOrPressEvent) => void;
}

const Icon: React.FC<IconProps> = props => {
    const { icon, className, onClick } = props;
    const iconName = kebabCase(icon) as IconString;
    const SpecificIcon = allIconComponents[iconName];

    if (!SpecificIcon) {
        return null;
    }

    const isClickableClass = onClick ? 'svg-icon-clickable' : '';

    const iconClass = `svg-icon ${isClickableClass} ${className ? className : ''}`;

    return <SpecificIcon onClick={onClick} className={iconClass} />;
};

export default Icon;
